
import { Map, fromJS } from 'immutable';
import actionTypes from '../actions/actionTypes';
import requestStatus from "../constants/requestStatus"


export const returnStateIfNoAction = (action, state) => {
    if(action === undefined) {
        return state;
    }
}

export const setSubstate = (substateKey, state) => substate => state.set(substateKey, substate)

export const onGet     = state             => state.set('status', requestStatus.REQUEST_PENDING)
                                                   .set('error', Map())
export const onSuccess = (state, action)   => state.set('status', requestStatus.REQUEST_SUCCESS)
                                                   .set('error', '')
                                                   .set('data', fromJS(action.payload))
export const onError   = (state, action)   => state.set('status', requestStatus.REQUEST_ERROR)
                                                   .setIn(['error','message'], action.payload.errorMessage)

export const dummyReducerFacory = initState => (state = initState)  => {
    return state
}

export const reducerFactory = (requestAction, successAction, errorAction, initState) => (state = initState, action) => {
    returnStateIfNoAction(action, state)


    switch(action.type) {
        case actionTypes[requestAction]:
            return onGet(state, action);
        case actionTypes[successAction]:
            return onSuccess(state, action);
        case actionTypes[errorAction]:
            return onError(state, action);
        default:
            return state;
    }
}


export const addItemToArray = (immutableState, keyArray, item) => {
    return immutableState.updateIn(
        keyArray,
        arr => arr.concat([item])
    )
}

export const deleteItemFromArray = (immutableState, keyArray, item) => {
    const arr = immutableState.getIn(keyArray)
    const itemIndex = arr.findIndex(i => i === item)

    if(-1 !== itemIndex) {
        immutableState = immutableState.deleteIn(keyArray.concat(itemIndex))
    }

    return immutableState
}

export const addIdUniqToArray = (immutableState, keyArray, id) => {
    if(-1 === immutableState.getIn(keyArray).findIndex(i => i === id)) {
        return addItemToArray(immutableState, keyArray, id)
    } else {
        return immutableState
    }
}